import { baseResourceOptions } from './utils';
import createCollectionResource from '../shared/createResource';
import emptyObserverCreator from 'src/actions/shared/emptyObserverCreator';
import SidekickAdmin from 'src/models/Sidekick/SidekickAdmin';

const sidekickAdminsResource = createCollectionResource<SidekickAdmin>({
  name: 'sidekickAdmins',
  endpoint: 'v1/orgs/:orgId/sidekick-dashboard/customers/:customerId/admins/:adminId',
  type: SidekickAdmin,
  observerCreator: emptyObserverCreator,
  options: baseResourceOptions,
});

export default sidekickAdminsResource;
